import * as React from 'react';
import { NavLink, NavLinkRenderProps, Outlet } from 'react-router-dom';
import { AppNavLink } from 'src/models/Utility/AppNavLink';

interface SidebarLayoutProps {
    links: AppNavLink[];
}

export function SidebarLayout({ links }: SidebarLayoutProps): JSX.Element {
    const isActiveTab = ({ isActive }: NavLinkRenderProps): string => isActive
        ? "navlink-active-background link-text"
        : "navlink-background link-text";

    return (
        <div className="flex-vertical gap-1 flex-fill">
            <div className="flex gap-1 flex-fill">
                <nav className="flex-vertical pt-2 gap-2 primary-light-right-border-strong" style={{ minWidth: '150px' }}>
                    {links.map((link: AppNavLink, index: number): JSX.Element => {
                        return (
                            <NavLink key={index} to={link.path} className={isActiveTab} end>
                                <div className="ma-2">{link.text}</div>
                            </NavLink>
                        );
                    })}
                </nav>

                <Outlet />
            </div>
        </div>
    );
}